import React, { useState, useEffect } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Box,
  Grid,
  GridItem,
  Text,
  Textarea,
} from "@chakra-ui/react";

import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";

import CriancaService from "../../../../../main/services/CriancaService";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";

export const OcorrenciasCadastrar = ({
  initialValues,
  valuesProps,
  setInitialValues,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const url = window.location.href;
  const { setCadastrarOcorCrianca } = useAppContext();

  const [tipoOcorrencias, setTipoOcorrencias] = useState({
    options: [],
    isLoading: false,
  });

  const handleGetTipoOcorrencias = () => {
    setTipoOcorrencias({
      ...tipoOcorrencias,
      isLoading: true,
    });

    CriancaService.getTipoOcorrencias().then((res) => {
      const tempOptions = res.data.map((ocorrencia) => {
        return {
          id: ocorrencia.id,
          descricao: ocorrencia.descricao,
        };
      });
      setTipoOcorrencias({
        options: tempOptions,
        isLoading: false,
      });
    });
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (url.includes("cadastrar")) {
      setInitialValues({
        dataOcorrencia: "",
        tipoOcorrencia: "",
        descricaoOcorrencia: "",
        justificativaOcorrencia: "",
      });
    }
  }, [setInitialValues, url, setFieldValue]);

  return (
    <Group title="Ocorrências">
      {setCadastrarOcorCrianca(hasFormChanged(initialValues, valuesProps))}
      <Grid mt="15px" templateColumns="repeat(3, 1fr)" gap="25px" rowGap="20px">
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
          <CustomDatepickerWField
            fieldName="dataOcorrencia"
            label="Data*"
            placeholder="DD/MM/AAAA"
            maxDate={new Date()}
          />
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />

        <GridItem colSpan={"3"}>
          <CustomSelectWField
            fieldName="tipoOcorrencia"
            label="Tipo*"
            placeholder="Selecione o tipo"
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={tipoOcorrencias.isLoading}
            options={tipoOcorrencias.options}
            onChange={(value) => {
              setFieldValue("tipoOcorrencia", value ? value : "");
            }}
            onFocus={
              tipoOcorrencias.options.length === 0
                ? handleGetTipoOcorrencias
                : null
            }
          />
          {values.tipoOcorrencia && values.tipoOcorrencia.id === 5 ? (
            <Box mt={3}>
              <Field name={"justificativaOcorrencia"}>
                {({ field, form }) => (
                  <Flex flexDir="column" position="relative">
                    <FormControl
                      isInvalid={
                        form.errors.justificativaOcorrencia &&
                        form.touched.justificativaOcorrencia
                      }>
                      <FormLabel
                        color="#5F6377"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="19.6px"
                        htmlFor="justificativaOcorrencia">
                        {"Justificativa*"}
                      </FormLabel>
                      <Textarea
                        {...field}
                        name="justificativaOcorrencia"
                        id="justificativaOcorrencia"
                        backgroundColor="#fff"
                        autoComplete="off"
                        border="1px solid #D7D8DE"
                        placeholder={"Informe a justificativa"}
                        maxLength={255}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 255) {
                            setFieldValue(
                              "justificativaOcorrencia",
                              e.target.value
                            );
                          }
                        }}
                      />
                      <Text
                        zIndex={10}
                        fontSize="sm"
                        position="absolute"
                        bottom="5px"
                        right="15px"
                        color={field.value.length === 255 ? "red" : "gray"}>
                        {field.value.length}/255
                      </Text>
                      <FormErrorMessage>
                        {form.errors.justificativaOcorrencia}
                      </FormErrorMessage>
                    </FormControl>
                  </Flex>
                )}
              </Field>
            </Box>
          ) : (
            <Box mt={3}>
              <Field name={"descricaoOcorrencia"}>
                {({ field, form }) => (
                  <Flex flexDir="column" position="relative">
                    <FormControl
                      isInvalid={
                        form.errors.descricaoOcorrencia &&
                        form.touched.descricaoOcorrencia
                      }>
                      <FormLabel
                        color="#5F6377"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="19.6px"
                        htmlFor="descricaoOcorrencia">
                        {"Descrição"}
                      </FormLabel>
                      <Textarea
                        {...field}
                        name="descricaoOcorrencia"
                        id="descricaoOcorrencia"
                        backgroundColor="#fff"
                        autoComplete="off"
                        border="1px solid #D7D8DE"
                        placeholder={"Informe a descrição"}
                        maxLength={255}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 255) {
                            setFieldValue(
                              "descricaoOcorrencia",
                              e.target.value
                            );
                          }
                        }}
                      />
                      <Text
                        zIndex={10}
                        fontSize="sm"
                        position="absolute"
                        bottom="5px"
                        right="15px"
                        color={field.value.length === 255 ? "red" : "gray"}>
                        {field.value.length}/255
                      </Text>
                      <FormErrorMessage>
                        {form.errors.descricaoOcorrencia}
                      </FormErrorMessage>
                    </FormControl>
                  </Flex>
                )}
              </Field>
            </Box>
          )}
        </GridItem>
        <GridItem colSpan={{ base: 3 }}></GridItem>
      </Grid>
    </Group>
  );
};
